<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>
      <v-card
        v-if="isUserValid"
        class="mx-auto" width="100%" max-width="500" outlined>
        <v-card-title>{{ $t('auth.createPassword') }}</v-card-title>
        <v-card-text>
          <v-form v-model="isValid">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="form.password"
                    :rules="rules.password"
                    :label="$t('auth.labels.newPassword')"
                    counter
                    :type="form.showPassword ? 'text' : 'password'"
                    @click:append="form.showPassword = !form.showPassword"
                    :append-icon="!form.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="form.passwordConfirmation"
                    :rules="rules.passwordConfirmation"
                    :label="$t('auth.labels.confirmPassword')"
                    counter
                    :type="form.showPasswordConfirmation ? 'text' : 'password'"
                    @click:append="form.showPasswordConfirmation = !form.showPasswordConfirmation"
                    :append-icon="!form.showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-btn
                    :disabled="!form.password || form.password !== form.passwordConfirmation"
                    color="primary"
                    @click="updatePassword">
                    {{ $t('ctas.save') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      <v-card
        v-else
        class="mx-auto" width="100%" max-width="500" outlined>
        <v-card-title>{{ $t('auth.linkExpired') }}</v-card-title>
        <v-card-text>
          Intenta de nuevo:
          <v-btn
            small
            text
            color="secondary"
            to="/recovery-password">
            {{ $t('auth.labels.forgotPassword') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
export default {

  name: 'ResetPassword',

  data () {
    return {
      overlay: false,
      isUserValid: true,
      isValid: false,
      form: {
        email: '',
        password: null,
        passwordConfirmation: null,
        showPassword: false,
        showPasswordConfirmation: false
      },
      rules: {
        password: [
          v => !!v || this.$t('validations.password')
        ],
        passwordConfirmation: [
          v => !!v || this.$t('validations.passwordConfirmation.required'),
          v => v === this.form.password || this.$t('validations.passwordConfirmation.match')
        ]
      }
    }
  },
  async created () {
    this.overlay = true
    const { token } = this.$route.query
    const url = encodeURI(`/v1/verify-user?resetPasswordToken=${token}`)
    try {
      const { email } = await this.$api.get(url)
      this.form.email = email
      this.isUserValid = true
    } catch (e) {
      this.$toasted.error(e.message, { duration: 3000 })
      this.isUserValid = false
    }
    this.overlay = false
  },
  methods: {
    async updatePassword () {
      try {
        if (this.$route.query.provider) {
          this.$store.commit('setUserprovider')
        }
        const response = await this.$api.post(`/v1/set-password/${this.$route.query.token}`, this.form)
        this.$store.commit('setSession', response)
        this.$toasted.success('Your password has been created', {
          duration: 3000
        })

        await this.$store.dispatch('login/signIn', this.form)
        if (this.$store.state.userProvider) {
          this.$router.push({ name: 'SelectProvider' })
        } else {
          this.$router.push({ name: 'SelectRestaurant' })
        }
      } catch (e) {
        this.$toasted.error(e.message, { duration: 3000 })
      }
    }
  }
}
</script>
